<style lang="stylus"></style>

<template>
    <Modal v-model="showVideoModal" :title="videoTitle" :width="700" :footer-hide="true" class-name="vertical-center-modal">
        <video :src="videoSrc" autoplay controls width="660" height="400"></video>
    </Modal>
</template>

<script lang="ts">
    declare var EDDocument: any;
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class EDHelpVideo extends Vue {
        videoData = {
            data: null,
            cache: false,
        };
        videoTitle = "";
        videoSrc = "";
        showVideoModal = false;

        clickHelpMenu() {
            let openVideo = () => {
                this.videoTitle = this.videoData.data.title;
                this.videoSrc = this.videoData.data.attach;
                this.showVideoModal = true;
            };
            if (this.videoData.cache) {
                openVideo();
            } else {
                this.$edApi
                    .getVideo({
                        class_id: 4,
                        user_id: 0,
                        platform: 1,
                        product: 2,
                    })
                    .then((list) => {
                        this.videoData.data = list.filter((v) => v.title == "入门视频")[0];
                        this.videoData.cache = true;
                        openVideo();
                    });
            }
        }

        mounted() {
            this.$bus.$on("showVideo", () => {
                this.clickHelpMenu();
            });
        }

        created() {}

        beforeDestroy() {
            this.$bus.$off("showVideo");
        }
    }
</script>
<i18n>
{
  "zh": {
    "starter": "新手向导",
    "video1": "入门视频",
    "lineStyle": "线条样式",
    "selAll": "选择所有",
    "defaultSet": "默认设置",
    "floatBtn": "浮动按钮",
    "collectSymbol": "收藏符号",
    "publishTemp": "发布模板"
  },
  "en": {
    "starter": "Get Started",
    "video1": "Getting Started Video",
    "lineStyle": "Line Style",
    "selAll": "Select All",
    "defaultSet": "Default Setting",
    "floatBtn": "Float Button",
    "collectSymbol": "Collect Symbol",
    "publishTemp": "Publish Template"
  },
  "fr": {
    "starter": "Guide novice",
    "video1": "Vidéo de démarrage",
    "lineStyle": "Style de ligne",
    "selAll": "Tout sélectionner",
    "defaultSet": "Paramètres par défaut",
    "floatBtn": "Bouton flottant",
    "collectSymbol": "Symbole de collection",
    "publishTemp": "Publier le modèle"
  },
  "de": {
    "starter": "Anfängerführung",
    "video1": "Einführungsvideo",
    "lineStyle": "Linienstil",
    "selAll": "Alles wählen",
    "defaultSet": "Voreinstellung",
    "floatBtn": "Float-Taste",
    "collectSymbol": "Symbole speichern",
    "publishTemp": "Vorlage veröffentlichen"
  },
  "jp": {
    "starter": "スタートガイド",
    "video1": "スタートガイド",
    "lineStyle": "線のスタイル",
    "selAll": "すべて選択",
    "defaultSet": "初期設定",
    "floatBtn": "フローティングボタン",
    "collectSymbol": "お気に入りの記号",
    "publishTemp": "テンプレートを公開する"
  },
  "es": {
    "starter": "Guía del novato",
    "video1": "Video de introducción",
    "lineStyle": "Estilo de línea",
    "selAll": "Seleccionar todo",
    "defaultSet": "Configuración predeterminada",
    "floatBtn": "Botón flotante",
    "collectSymbol": "coleccionar símbolo",
    "publishTemp": "Publicar plantilla"
  },
  "pt": {
    "starter": "Guia para Principiantes",
    "video1": "Vídeo de Introdução",
    "lineStyle": "Estilo de Linha",
    "selAll": "Selecionar tudo",
    "defaultSet": "Configuração Padrão",
    "floatBtn": "Botão Flutuante",
    "collectSymbol": "Coletar Símbolo",
    "publishTemp": "Publicar Modelo"
  },
  "it": {
    "starter": "Guida per principianti",
    "video1": "Video per iniziare",
    "lineStyle": "Stile della linea",
    "selAll": "Scegli tutto",
    "defaultSet": "Impostazioni predefinite",
    "floatBtn": "Pulsante fluttuante",
    "collectSymbol": "Salva simbolo",
    "publishTemp": "Pubblica il modello"
  },
  "tw": {
    "starter": "新手嚮導",
    "lineStyle": "線條樣式",
    "selAll": "選擇所有",
    "defaultSet": "默認設置",
    "floatBtn": "浮動按鈕",
    "collectSymbol": "收藏符號",
    "publishTemp": "發佈模板"
  }
}
</i18n>
